import { ListboxDataItem } from '@/components/Listbox';

export function compareListBoxDataItemsByLabel(itemA: ListboxDataItem, itemB: ListboxDataItem) {
  return itemA?.label?.localeCompare(itemB?.label);
}
